<div class="head" [ngClass]="{'green': color === 'green'}" (click)="opened = !opened">
    <div class="title font-large">{{title | translate}}</div>
    <div *ngIf="hasDate" class="last-saved font-small">{{'__REVIEW_REPORT_LIST_HEADER_LAST_SAVED__' | translate}}: {{date ? (date | amDateFormat : 'DD/MM/YYYY'): '--/--/----'}}</div>
    <img src="assets/img/plus-white.svg" alt="plus" *ngIf="!opened" [ngClass]="{'active': !opened}">
    <img src="assets/img/minus-white.svg" alt="minus" *ngIf="opened" [ngClass]="{'active': opened}">
</div>
<div class="dropdown-box-content font-larger" [ngClass]="{'active': opened}">
    <ng-content></ng-content>
</div>
